import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { ActionType } from 'typesafe-actions'
import { DeliveryTrackingActionTypes } from './types'
import { reschedule } from './service'
import { rescheduleRequestFail, rescheduleRequestSuccess } from './actions'
import * as AnalyticsManager from '../../lib/analytics/analytics'

const MESSAGE_TIMEOUT: number = 3

function* handleReschedule(action: ActionType<string>) {
  try {
    AnalyticsManager.sendEvent(AnalyticsManager.Event.RescheduleRequest)
    const { payload } = action
    yield call(reschedule, payload)
    // message.success('success', MESSAGE_TIMEOUT)
    yield put(rescheduleRequestSuccess())
    AnalyticsManager.sendEvent(AnalyticsManager.Event.RescheduleRequestSuccess)
  } catch (error) {
    yield put(rescheduleRequestFail())
    // message.error('failure', MESSAGE_TIMEOUT)
    AnalyticsManager.sendEvent(AnalyticsManager.Event.RescheduleRequestFail)
  } finally {
    yield call(delay, MESSAGE_TIMEOUT)
    // yield put(rescheduleClose())
  }
}

function* handleRescheduleOpen() {
  yield AnalyticsManager.sendEvent(AnalyticsManager.Event.RescheduleOpen)
}

function* handleRescheduleClose() {
  yield AnalyticsManager.sendEvent(AnalyticsManager.Event.KeepCurrentSchedule)
}

function* watchReschedule() {
  yield takeEvery(DeliveryTrackingActionTypes.RESCHEDULE_REQUEST, handleReschedule)
  yield takeEvery(DeliveryTrackingActionTypes.RESCHEDULE_OPEN, handleRescheduleOpen)
  yield takeEvery(DeliveryTrackingActionTypes.RESCHEDULE_CLOSE, handleRescheduleClose)
}

function* DeliveryTrackingSaga() {
  yield all([fork(watchReschedule)])
}

export default DeliveryTrackingSaga
